module.exports = __webpack_public_path__ + "static/media/editpencil.338a84fb.svg";